// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2Dv2h","title":"AfterBackImages_title__2Ehg8","images":"AfterBackImages_images__3x7N0"};